import { styled } from '@mui/material';

import type { Theme } from '@mui/material';

export const IndefiniteText = styled('span')({
  fontStyle: 'italic'
});

/**
 * One size for every icon on a protocol's detail: the card's pencil, and a rule's note, pencil and
 * trash can — a touch larger than the body text.
 */
export const protocolIconSize = (theme: Theme) => ({
  width: theme.typography.pxToRem(22),
  height: theme.typography.pxToRem(22)
});
